/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { FC } from 'react';
import { Table } from '@/components';
import { DocumentTableData } from '@/types/depo20';

import { getTableColumns } from './tableColumns';

type Depo20TableProps = {
  data?: DocumentTableData[] | undefined;
  isLoading?: boolean;
  selectedItems: any[];
  handleSelectionChange: (e: { value: any }) => void;
  fechaLiquidacion: string | undefined;
};

const Depo20Table: FC<Depo20TableProps> = ({
  data,
  isLoading,
  selectedItems,
  handleSelectionChange,
  fechaLiquidacion,
}) => {
  const tableColumns = getTableColumns();

  const dataWithFechaLiquidacion = data?.map((val) => {
    return { ...val, fechaLiquidacion };
  });

  return (
    <Table
      columns={tableColumns}
      data={dataWithFechaLiquidacion}
      isLoading={isLoading}
      filterDisplay="menu"
      paginator
      selectableColumns
      selectionId="numero"
      selectedItems={selectedItems}
      onSelectionChange={handleSelectionChange}
    />
  );
};

export default Depo20Table;
